import React, { Fragment } from "react";
import { RotatingLines } from "react-loader-spinner";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../components/css/style.css";
import "../components/css/color.css";
import "../components/css/popup.css";
const rootStyles = getComputedStyle(document.documentElement);
const rootColor = rootStyles.getPropertyValue("--theme");
//const rootColor="#3550dc";

export const xAuth = "M@#weh@##dhASD2627@#2024";

/* ############ OCM service ########## 
export const service="ocm";
export const countryCode="237";
export const flag="cm";
export const lang="fr";
export const serviceId=1;
export const serviceName="UVGAMING";
//export const baseUrl = "/ocmapi";
export const baseUrl = "https://ocm.uvcanngaming.com/ocmApi";  */

/* ############ OGB service ########## */
export const service = "ogb";
export const countryCode = "245";
export const flag = "gw";
export const lang = "pr";
export const serviceId = 1;
export const serviceName = "UVGAMING";
//export const baseUrl = "/ocmapi";
export const baseUrl = "https://ogb.uvcanngaming.com/ogbApi";

/* ############ mng service ########## 
export const service="mng";
export const countryCode="227";
export const flag="ne";
export const lang="fr";
export const serviceId=1;
export const serviceName="MOOVGAMING"
export const baseUrl = "https://mng.uvcanngaming.com/mngApi";  */

/* ############ mtg service ##########  
export const service = "mtg";
export const countryCode = "228";
export const flag = "tg";
export const lang = "fr";
export const serviceId = 1;
export const serviceName = "MOOVGAMES";
export const baseUrl = "/mtgApi";
//export const baseUrl = "https://mtg.uvcanngaming.com/mtgApi"; */

/* ############ mgb service ##########  
export const service = "mgb";
export const countryCode = "241";
export const flag = "ga";
export const lang = "fr";
export const serviceId = 1;
export const serviceName = "MOOVGAMES";
export const baseUrl = "https://mgb.uvcanngaming.com/mgbApi"; */

/* ############ mueg service ##########  
export const service="mueg";
export const countryCode="240";
export const flag="gq";
export const lang="sp";
export const serviceId=1;
export const serviceName="MUNI GAMES;
export const baseUrl = "https://mueg.uvcanngaming.com/muegApi"; */

/* ############ VTZ service ##########  
export const service = "vmz";
export const countryCode = "255";
export const flag = "tz";
export const lang = "swc";
export const serviceId = 1;
export const serviceName = "UVGAMING";
//export const baseUrl = "/ocmapi";
export const baseUrl = "https://vtz.uvcanngaming.com/vtzApi"; */

export const brandImages = [
  "/images/brand_1.png",
  "/images/brand_2.png",
  "/images/brand_3.png",
  "/images/brand_4.png",
  "/images/brand_2.png",
  "/images/brand_5.png",
];

export const footerImages = [
  "/images/footer_3.png",
  "/images/footer_2.png",
  "/images/footer_1.png",
  "/images/footer_4.png",
  "/images/footer_5.png",
];

export const Loader = () => {
  return (
    <div style={{ width: "100px", margin: "auto" }}>
      <RotatingLines
        strokeColor="grey"
        strokeWidth="5"
        animationDuration="0.75"
        width="60"
        visible={true}
      />
    </div>
  );
};
export const getLanguages = () => {
  let languages = [];
  if (service === "ogb") {
    languages = [
      { value: "pr", label: "Portuguese" },
      { value: "en", label: "English" },
    ];
  } else if (service === "mueg") {
    languages = [
      { value: "sp", label: "Spanish" },
      { value: "en", label: "English" },
    ];
  } else if (service === "vmz") {
    languages = [
      { value: "swc", label: "Swahili" },
      { value: "en", label: "English" },
    ];
  } else {
    languages = [
      { value: "fr", label: "French" },
      { value: "en", label: "English" },
    ];
  }
  return languages;
};
export const Notify = (props) => {
  console.log("props=" + props);
  if (props.message) {
    if (props.type) toast.success(props.message);
    else toast.warning(props.message);
  }
  // inbuilt-notification
  /* toast.success("successful");
    // inbuilt-notification
    toast.info("GeeksForGeeks");
    // inbuilt-notification
    toast.error("Runtime error");
    // default notification
    toast("Hello Geeks");*/

  return <ToastContainer />;
};

export const Random = () => {
  let rnd = Math.floor(Math.random() * 90000) + 10000;
  return rnd + "" + Date.now();
};

export const PopupSub = (props) => {
  console.log("sub=" + props.subStatus);
  return (
    <div className="popup-container">
      <div className="popup1">
        {props.subStatus === 206 ? (
          <>
            <div>
              <h3 className="login-title mb-3 mt-3 text-center">
                {props.detail}
              </h3>
              <h3 className="login-title mb-3 mt-3 text-center">
                {props.confirm}
              </h3>
            </div>
            <div>&nbsp;</div>
            <div className="popupDiv col-12">
              <div className="popupDivLeft col-6">
                <a className="popupBtnRed" onClick={() => props.redirectTo(2)}>
                  {props.no}
                </a>{" "}
              </div>
              <div className="popupDivRight col-6">
                <a className="popupBtn" onClick={() => props.redirectTo(1)}>
                  {props.yes}
                </a>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export const customStyles = {
  control: (provided) => ({
    ...provided,
    backgroundColor: rootColor,
    fontSize: "18px",
    fontWeight: 700,
    color: rootColor,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    borderRadius: "10px",
    border: "none",
    outline: "none",
    margin: "0 auto",
    minHeight: "40px",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#fff",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#fff",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? rootColor : "#fff",
    color: state.isSelected ? "#fff" : "#000",
    cursor: "pointer",
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "10px",
    marginTop: "5px",
  }),
};
